var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.11719 1.11719 0 2.5 0H32.5C33.8828 0 35 1.11719 35 2.5C35 3.88281 33.8828 5 32.5 5H2.5C1.11719 5 0 3.88281 0 2.5ZM0 15C0 13.6172 1.11719 12.5 2.5 12.5H32.5C33.8828 12.5 35 13.6172 35 15C35 16.3828 33.8828 17.5 32.5 17.5H2.5C1.11719 17.5 0 16.3828 0 15ZM35 27.5C35 28.8828 33.8828 30 32.5 30H2.5C1.11719 30 0 28.8828 0 27.5C0 26.1172 1.11719 25 2.5 25H32.5C33.8828 25 35 26.1172 35 27.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.be44edbbd22ee6e626ab33d0f0c9d742.svg";
export { ForwardRef as ReactComponent };